import { Outlet } from 'react-router'

export const PrivateLayout = () => (
	<div className='h-full overflow-hidden'>
		<div className='flex h-full flex-col overflow-y-auto'>
			<Outlet />
		</div>
	</div>
)
